module.exports = __webpack_public_path__ + "img/ring_r_o_null_null@3x.609e390d.png";